import { ServiceTypeSelectorOption } from "../../types/order";
import { isRoomFamily } from "../../util/useCases";

// Services that require/support an explicit rental start via /rental/start:
// these station and handover services, and every room-family use case.
const SERVICES_WITH_START_RENTAL = new Set<string>([
  ServiceTypeSelectorOption.RENTAL,
  ServiceTypeSelectorOption.STORAGE,
  ServiceTypeSelectorOption.P2P,
  ServiceTypeSelectorOption.SUP,
  ServiceTypeSelectorOption.KEYS,
]);

/** Does starting this booking call /rental/start (`OrdersPage.startUsingOrder`)? */
export const supportsStartRental = (service: string | null | undefined): boolean =>
  (service != null && SERVICES_WITH_START_RENTAL.has(service)) || isRoomFamily(service);
